// src/lib/i18nRoutes.js
export const SUPPORTED_LANGS = ["en", "fr", "ar", "de"];

// ضع هنا اللغة الافتراضية للموقع
export const DEFAULT_LANG = "en";

/**
 * withLangPrefix(path, lang)
 * - يضع بادئة اللغة على المسار (يتعامل مع مسارات تبدأ بـ "/" أو بدون)
 * - مثال: withLangPrefix("/articles/slug", "fr") => "/fr/articles/slug"
 */
// src/lib/i18nRoutes.js (مثال)
export function withLangPrefix(path, lang) {
  if (!path) path = "/";
  // ensure path starts with single slash
  path = path.replace(/^\/+/, "/");
  // if path already contains /:lang/ at start, strip it
  path = path.replace(/^\/(en|fr|ar|de)(\/|$)/, "/");
  // build prefixed path
  const p = `/${(lang || "en").replace(/[^a-z]/g, "").toLowerCase()}${path}`;
  return p.replace(/\/{2,}/g, "/");
}


/**
 * stripLangPrefix(path)
 * - يزيل بادئة اللغة إن وُجدت ويعيد { lang, rest }
 * - مثال: "/fr/articles/hello" => { lang: "fr", rest: "/articles/hello" }
 */
export function stripLangPrefix(path = "/") {
  const p = (path || "/").replace(/\/+$/, "") || "/";
  const parts = p.split("/").filter(Boolean); // removes empty
  if (parts.length === 0) return { lang: null, rest: "/" };
  const first = parts[0].toLowerCase();
  if (SUPPORTED_LANGS.includes(first)) {
    const rest = "/" + parts.slice(1).join("/");
    return { lang: first, rest: rest === "/" ? "/" : rest };
  }
  return { lang: null, rest: p === "" ? "/" : p };
}

/**
 * ensureLangInPath(path, lang)
 * - يضمن أن المسار يحتوي البادئة المطلوبة (يستبدل إن كانت مختلفة)
 */
export function ensureLangInPath(path = "/", lang = DEFAULT_LANG) {
  const { rest } = stripLangPrefix(path);
  return withLangPrefix(rest, lang);
}
